// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-2ccc0d54] {\n  padding-bottom: 35px;\n}\n", ""]);
// Exports
module.exports = exports;
